import type { VehicleType } from "@/lib/api/types"
import type { BodyType } from "./outlines"

// The car's body type, for the small "this view" drawing in the camera:
// from the VIN's lookup (its vehicle type), else a sedan. Pure; unit-tested.

export const DEFAULT_BODY: BodyType = "sedan"

export function bodyTypeFor(type: VehicleType | null | undefined): BodyType | null {
  switch (type) {
    case "Sedan":
      return "sedan"
    case "Hatchback":
    case "StationWagon":
    case "Compact":
    case "CityCar":
    case "SuperMini":
      return "sportback"
    case "Coupe":
    case "Convertible":
      return "sports"
    case "SUV":
    case "Crossover":
    case "MiniVan":
    case "Van":
    case "CargoVan":
      return "suv"
    case "Pickup":
      return "pickup"
    default:
      return null
  }
}
